module.exports = __webpack_public_path__ + "static/media/import-url-link.2f27cbce.svg";